export const ROOT_DB_URL = "businesses"
export const CUSTOMER_COLLECTION = "customers"
export const USERACCESSES_COLLECTION = "useraccesses"
export const PRODUCERS_COLLECTION = "producers"
export const FIELDS_COLLECTION = "fields"
export const NOTES_COLLECTION = "notes"
export const DISTRIBUTORS_COLLECTION = "distributors"
export const ORGANIZATIONS_COLLECTION = "organizations"
export const PROCESSINGS_COLLECTION = "processings"
export const STATISTICS_COLLECTION = "statistics"
export const SUBSCRIPTIONS_CONTRACTS_COLLECTION = "contracts"
export const PRODUCTIONS_COLLECTION = "productions"
export const FIELD_PRODUCERS_REF = "producer_ref"
export const STATISTIC_FIELD_REF = "field_ref"
export const STATISTICS_CAMPAIGN_YEAR = "campaign_year"
export const STATISTIC_INDICATOR_TYPE = "indicator_type"
export const TERMS_AND_CONDITIONS_URL = "https://storage.googleapis.com/terranis-prod.appspot.com/businesses/viti/terms_conditions.pdf"
